import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileText, ListChecks } from "lucide-react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

let remembered = null;

export function useReportFields() {
  const [all, setAll] = useState([]);
  const [picked, setPicked] = useState(null);
  useEffect(() => {
    api.get("/admin/hr/export/fields").then((r) => {
      const keys = r.data.map((x) => x.key);
      setAll(r.data);
      setPicked(remembered ? remembered.filter((k) => keys.includes(k)) : keys);
    }).catch(() => toast.error("Rapor alanları yüklenemedi"));
  }, []);
  const save = (keys) => { setPicked(keys); remembered = keys; };
  return { all, picked: picked || [], ready: picked !== null, save };
}

export function ReportFieldsDialog({ open, onOpenChange, rf, onExport }) {
  const { all, picked, save } = rf;
  const keys = all.map((x) => x.key);
  const toggle = (k) => save(picked.includes(k) ? picked.filter((x) => x !== k) : keys.filter((x) => x === k || picked.includes(x)));
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[92vh] max-w-xl overflow-y-auto" data-testid="report-fields-dialog">
        <DialogHeader><DialogTitle>Rapor Alanlarını Seç</DialogTitle></DialogHeader>
        <p className="text-sm text-zinc-500">Başvuru no, başvuru tarihi ve durum her raporda yer alır. <b data-testid="report-fields-count">{picked.length}/{all.length}</b> alan seçili.</p>
        <div className="flex flex-wrap gap-2">
          <button onClick={() => save(keys)} className="btn-outline !px-3 !py-1.5 text-xs" data-testid="report-fields-select-all">Tümünü Seç</button>
          <button onClick={() => save([])} className="btn-outline !px-3 !py-1.5 text-xs" data-testid="report-fields-clear">Tüm Seçimleri Kaldır</button>
          <button onClick={() => save(keys)} className="btn-outline !px-3 !py-1.5 text-xs" data-testid="report-fields-default">Varsayılan Alanları Seç</button>
        </div>
        <div className="grid gap-1 rounded-lg border border-zinc-200 p-2">
          {all.map((x, i) => (
            <label key={x.key} className="flex cursor-pointer items-center gap-3 rounded px-2 py-1.5 text-sm hover:bg-zinc-50">
              <input type="checkbox" checked={picked.includes(x.key)} onChange={() => toggle(x.key)} className="h-4 w-4 accent-[color:var(--red)]" data-testid={`report-field-${x.key}`} />
              <span className="w-5 text-xs text-zinc-400">{i + 1}.</span>{x.label}
            </label>
          ))}
        </div>
        {!picked.length && <p className="rounded bg-orange-50 px-3 py-2 text-sm text-orange-800" data-testid="report-fields-warning">Rapor oluşturmak için en az bir alan seçin.</p>}
        <div className="flex flex-wrap justify-end gap-2">
          <button onClick={() => onExport("xlsx")} className="btn-outline !py-2" data-testid="report-export-xlsx"><FileSpreadsheet className="h-4 w-4" /> Seçilen Alanlarla Excel İndir</button>
          <button onClick={() => onExport("pdf")} className="btn-red !py-2" data-testid="report-export-pdf"><FileText className="h-4 w-4" /> Seçilen Alanlarla PDF İndir</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export function ReportFieldsButton({ onClick, rf }) {
  return (
    <button onClick={onClick} className="btn-outline !py-2" data-testid="report-fields-open">
      <ListChecks className="h-4 w-4" /> Rapor Alanlarını Seç {rf.ready && <span className="text-xs text-zinc-500">({rf.picked.length})</span>}
    </button>
  );
}
